module.exports = __webpack_public_path__ + "media/images/shopify_faq_10-432775d78c49ea89b0da4ce0e7ba2722.png";